import React from "react";
import RichTextEditor from "react-rte";

export default function ReactTextArea({ lable, valuename,mainvalue, onChangeFunction, Fieldname }) {
  return (
    <>
      <div className="userUpdateItem">
        <label className="user__label">{lable}</label>

        <RichTextEditor
          className="desc_area"
          value={mainvalue}
          onChange={(value) => onChangeFunction(value, Fieldname, valuename)}
        />
      </div>
    </>
  );
}
